import React, { useState } from 'react';
import { SwiperComponent } from 'vitl-component-library';
import Image from '@components/image/image';

import { usePartnersText } from '@hooks/useContent';
import styles from './partners-slider.module.scss';

interface IProps {
  isWhite?: boolean;
  backgroundColor?: string;
  className?: string;
}

const DEFAULT_BACKGROUND_COLOR = '#fef6dc';
const SWIPER_ARROW_ICON =
  "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21'%3e %3cdefs%3e %3cstyle%3e.a%7bfill:%23DBDBDB%3b%7d.b%7bfill:none%3b%7d%3c/style%3e %3c/defs%3e %3cg transform='translate(21 21) rotate(180)'%3e %3cpath class='a' d='M11.441%2c11.76l7.945%2c7.928%2c7.945-7.928L29.772%2c14.2%2c19.386%2c24.587%2c9%2c14.2Z' transform='translate(-9 -7.76)'/%3e %3cpath class='b' d='M0%2c0H21V21H0Z'/%3e %3c/g%3e%3c/svg%3e";

const PartnersSlider = ({ isWhite, backgroundColor = 'rgba(255,255,255, 0.75)', className }: IProps) => {
  const partners = usePartnersText();
  const [swiperInstance, setSwiperInstance] = useState<any>();

  const getBackgroundColor = () => {
    if (isWhite) {
      return '#ffffff';
    }

    if (backgroundColor) {
      return backgroundColor;
    }

    return DEFAULT_BACKGROUND_COLOR;
  };

  const ArrowPrev = () => (
    <div className={styles.leftArrowWrapper} onClick={() => swiperInstance?.slidePrev()}>
      <img alt="swiper arrow left" src={SWIPER_ARROW_ICON} width={20} />
    </div>
  );

  const ArrowNext = () => (
    <div className={styles.rightArrowWrapper} onClick={() => swiperInstance?.slideNext()}>
      <img alt="swiper arrow right" src={SWIPER_ARROW_ICON} width={20} />
    </div>
  );

  return (
    <section
      className={`${styles.slider} ${className ? className : ''}`}
      style={{ backgroundColor: getBackgroundColor() }}
    >
      <p>{partners.partners_header}</p>
      <div className={styles.swiperContainer}>
        <div className={styles.swiperContent}>
          <ArrowPrev />
          <SwiperComponent
            onInit={(swiper) => setSwiperInstance(swiper)}
            pagination={false}
            spaceBetween={16}
            slideToClickedSlide
            breakpoints={{
              320: {
                slidesPerView: 1,
              },
              375: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 4,
              },
              1024: {
                slidesPerView: 3.8,
              },
              1366: {
                slidesPerView: 5,
              },
            }}
          >
            {partners?.partner_logos?.map((item, index) => (
              <div key={index} className={styles.slidePicture}>
                <Image className={styles.partnerLogo} filename={item.image_hash} width={500} noBlurLoading />
              </div>
            ))}
          </SwiperComponent>
          <ArrowNext />
        </div>
      </div>
    </section>
  );
};

export default PartnersSlider;
